import { render, staticRenderFns } from "./period-input.vue?vue&type=template&id=642b98e8&scoped=true&"
import script from "./period-input.vue?vue&type=script&lang=ts&"
export * from "./period-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b98e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('642b98e8')) {
      api.createRecord('642b98e8', component.options)
    } else {
      api.reload('642b98e8', component.options)
    }
    module.hot.accept("./period-input.vue?vue&type=template&id=642b98e8&scoped=true&", function () {
      api.rerender('642b98e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/period-input.vue"
export default component.exports